// Autogenerated file, DO NOT MODIFY or it will be overwritten;
import type { SVGProps } from 'react';

import { forwardRef } from '@chakra-ui/react';

import { Icon, type IconProps } from '../Icon';

const Svg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fill="currentColor"
      d="M11.3291 0.928937C15.3279 1.50975 18.4902 4.67202 19.071 8.67081C19.1284 9.06613 19.1571 9.26379 19.0778 9.46817C19.0141 9.63223 18.8642 9.80545 18.711 9.89206C18.5202 9.99995 18.2912 9.99995 17.8333 9.99995H11.3333C10.8666 9.99995 10.6333 9.99995 10.455 9.90912C10.2982 9.82922 10.1707 9.70174 10.0908 9.54494C10 9.36668 10 9.13332 10 8.66661V2.16661C10 1.70871 10 1.47976 10.1079 1.28891C10.1945 1.13571 10.3677 0.985825 10.5318 0.922143C10.7362 0.842808 10.9338 0.871517 11.3291 0.928937Z"
    />
    <path
      fill="currentColor"
      d="M8.33335 2.58498C8.33335 2.05325 8.33335 1.78739 8.19776 1.57974C8.09019 1.41502 7.87462 1.26543 7.68267 1.22231C7.4407 1.16795 7.22462 1.24868 6.79244 1.41013C3.31176 2.71043 0.833334 6.06575 0.833334 9.99995C0.833334 15.0626 4.93739 19.1666 10 19.1666C13.9342 19.1666 17.2895 16.6882 18.5898 13.2075C18.7513 12.7754 18.832 12.5593 18.7776 12.3173C18.7345 12.1253 18.5849 11.9098 18.4202 11.8022C18.2126 11.6666 17.9467 11.6666 17.415 11.6666L11.2948 11.6666C11.0963 11.6667 10.8592 11.6668 10.6503 11.6497C10.4083 11.6299 10.0616 11.5792 9.69838 11.3941C9.22797 11.1544 8.84552 10.772 8.60584 10.3016C8.42076 9.93835 8.37002 9.59169 8.35024 9.34966C8.33318 9.1408 8.33327 8.9037 8.33334 8.70518L8.33335 2.58498Z"
    />
  </svg>
);
const IconChartPieFill = forwardRef((props: Omit<IconProps, 'icon'>, ref) => {
  return <Icon ref={ref} icon={Svg} {...props} />;
});
export default IconChartPieFill;
